module.exports = __webpack_public_path__ + "img/logo_3.d9ab8505.png";